import PostMenuPopover from '@src/components/Post/PostMenuPopover/PostMenuPopover';
import TokenImage from '@src/components/Token/TokenImage/TokenImage';
import TokenStats from '@src/components/Token/TokenStats';
import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import { memo } from 'react';
import type { FC } from 'react';
import { PostHero } from '../PostHero';

export interface PostTabHeroProps {
    postId: string;
    tokenName: string;
    className?: string;
    fallbackImage?: string;
}

const PostTabHero: FC<PostTabHeroProps> = props => {
    const { tokenName, postId, className } = props;

    const avatarSizeClasses = 'size-[64px] lg:size-[100px]';
    const spaceAfterAvatar = 'ml-3 lg:ml-4';

    function renderMenuPopover() {
        return <PostMenuPopover postId={postId} className="" tokenName={tokenName} />;
    }

    function renderTokenStats() {
        return (
            <div className={`flex-1 ${spaceAfterAvatar}`}>
                <TokenStats tokenName={tokenName} />
            </div>
        );
    }
    return (
        <div className={className}>
            <PostHero postId={postId} tokenName={tokenName} />

            <div className={'flex px-4 pt-1 lg:pt-2 relative z-10'}>
                <TokenImage className={`flex-shrink-0 -mt-[48px] lg:-mt-[84px] ${avatarSizeClasses}`} tokenName={tokenName} />
                {renderTokenStats()}
                <div className="flex-1" />
                {renderMenuPopover()}
            </div>
        </div>
    );
};

export default memo(PostTabHero, propsEqualityFn);
